module.exports = __webpack_public_path__ + "img/OBCINA ZALEC.184b10b5.png";